<header>
  <button type="button" class="hamburger" aria-label="Menú" (click)="toggleMenu()" [attr.aria-expanded]="isMenuOpen">
    <span></span>
    <span></span>
    <span></span>
  </button>

  <div class="brand" aria-label="teu">
    <a href="/cliente">
      <img class="brand-img" src="/assets/logoteu.png" alt="" />
    </a>
  </div>

  <nav class="nav-pill" aria-label="Navegación" [class.is-open]="isMenuOpen">
    <a href="/cliente" (click)="isMenuOpen = false">
      <span class="dot"><img src="/assets/logo.png" alt="" /></span>
      Crédito
    </a>
    <a href="/promotor" (click)="isMenuOpen = false">
      <span class="dot"><img src="/assets/logo.png" alt="" /></span>
      Ser PromoTeur
    </a>
    <!--<a href="#contacto" (click)="isMenuOpen = false">
      <span class="dot"><img src="/assets/logo.png" alt="" /></span>
      Contacto
    </a>-->
  </nav>
</header>